define('modules/start/dashboard/engagement/view',['require','exports','module','views/BaseView','i18n','helpers/d3pie','env','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");
    var i18n = require("i18n");
    var D3pieHelper = require("helpers/d3pie");
    var pie;
    var Config = require("env");
    var container = "#pie-chart";

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        showEngagementInfo: false,
        events: {
            "render:pie": "onRenderPie"
        },
        initialize: function() {
            if( parseInt(this.productsReport.get("active_users")) === 0 && 
                parseInt(this.productsReport.get("inactive_users")) === 0){
                this.showEngagementInfo = true;
            }
            $(window).on('resize.resizeview', this.render.bind(this));
        },
        serialize: function() {
            return {
                showEngagementInfo: this.showEngagementInfo,
                mdirectorUrl: Config.mdirectorUrl
            };
        },
        initPopover: function() {
            $("#engagementHelp").popover({
                container: 'body',
                title: '<strong>'+ i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.ENGAGEMENT")+
                        '</strong><a href="javascript:$(\'#engagementHelp\').popover(\'hide\');"'+
                        ' style="float: right; text-decoration: none;color: #000000;">x</a>',
                html: true,
                trigger : 'click',
                placement: 'left',
                content: i18n.t("PUBLIC.PRODUCTS.DASHBOARD.HELP.ENGAGEMENT"),
                template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
            });
        },
        onRenderPie: function(event, data) {
            this.renderPie(data.active, data.inactive);
        },
        renderPie: function(actives, inactives) {
            var widthContainer = $(container).width();
            var labelsOuterFormat = "label";
            var labelsInnerFormat = "percentage";
            var labelsMainLabelColor = "#000000";
            var D3pie = D3pieHelper.getD3Pie();
            if (widthContainer < 258) {
                labelsOuterFormat = "none";
                labelsInnerFormat = "label-percentage2";
                labelsMainLabelColor = "#ffffff";
            }
            if (pie) {
                try {
                    pie.destroy();
                } catch (err) {}
            }

            pie = new D3pie(container, {
                data: {
                    content: [{
                        label: i18n.t("PUBLIC.PRODUCTS.DASHBOARD.ACTIVE_USERS"),
                        value: actives,
                        color: "#20A1D1"
                    }, {

                        label: i18n.t("PUBLIC.PRODUCTS.DASHBOARD.INACTIVE_USERS"),
                        value: inactives,
                        color: "#585858"
                    }]
                },
                labels: {
                    outer: {
                        format: labelsOuterFormat,
                        pieDistance: 10,
                        font: "Raleway",
                        color: "#000000",
                    },
                    inner: {
                        format: labelsInnerFormat
                    },
                    mainLabel: {
                        color: labelsMainLabelColor,
                        font: "Raleway",
                        fontSize: 12
                    },
                    percentage: {
                        font: "Raleway",
                        fontSize: 12,
                        color: "#ffffff",
                        decimalPlaces: 0
                    },
                    value: {
                        color: "#ffffff",
                        font: "Raleway",
                        fontSize: 12
                    }
                },
                size: {
                    canvasWidth: widthContainer,
                    canvasHeight: 176,
                    pieInnerRadius: "3%",
                    pieOuterRadius: "80%"
                },
                tooltips: {
                    enabled: true,
                    type: "placeholder",
                    string: "{value} " + i18n.t("PUBLIC.PRODUCTS.DASHBOARD.TITLES.USERS"),
                    styles: {
                        backgroundColor: "#232323",
                        backgroundOpacity: 1,
                        borderRadius: 8,
                        font: "Raleway",
                        fontSize: 12,
                        padding: 5
                    }
                },
                effects: {
                    load: {
                        effect: "none"
                    },
                    pullOutSegmentOnClick: {
                        effect: "none"
                    }
                }
            });
        },

        afterRender: function() {
            BaseView.prototype.afterRender.call(this);
            $('.popover').remove();
            this.initPopover();
            if ($(container).length &&
                    (this.productsReport.get("active_users") > 0 || this.productsReport.get("inactive_users") > 0)) {
                this.renderPie(
                        this.productsReport.get("active_users"),
                        this.productsReport.get("inactive_users")
                        );
            }
        }
    });

    module.exports = Layout;

});

